export const companyType = {
  organizer: "EVENT_ORGANIZER",
  vendor: "VENDOR",
  service_provider: "SERVICE_PROVIDER",
};
